/**
 * 活动/届次状态枚举
 *
 * 状态流转：
 * DRAFT -> PUBLISHED -> IN_PROGRESS -> COMPLETED -> ARCHIVED
 */
export enum EventStatus {
  /** 草稿 - 初始创建状态，仅创建者可见 */
  DRAFT = 'DRAFT',
  /** 已发布 - 已发布到嘉宾端，嘉宾可见 */
  PUBLISHED = 'PUBLISHED',
  /** 进行中 - 活动正在进行 */
  IN_PROGRESS = 'IN_PROGRESS',
  /** 已完成 - 活动已结束 */
  COMPLETED = 'COMPLETED',
  /** 已归档 - 活动数据已归档，邀约码自动失效 */
  ARCHIVED = 'ARCHIVED',
}

/** 所有状态值的数组 */
export const EventStatusValues: string[] = Object.values(EventStatus);

/** 状态中文标签映射 */
export const EventStatusLabels: Record<EventStatus, string> = {
  [EventStatus.DRAFT]: '草稿',
  [EventStatus.PUBLISHED]: '已发布',
  [EventStatus.IN_PROGRESS]: '进行中',
  [EventStatus.COMPLETED]: '已完成',
  [EventStatus.ARCHIVED]: '已归档',
};

/** 合法的状态流转映射 */
export const EventStatusTransitions: Record<EventStatus, EventStatus[]> = {
  [EventStatus.DRAFT]: [EventStatus.PUBLISHED],
  [EventStatus.PUBLISHED]: [EventStatus.IN_PROGRESS, EventStatus.DRAFT],
  [EventStatus.IN_PROGRESS]: [EventStatus.COMPLETED],
  [EventStatus.COMPLETED]: [EventStatus.ARCHIVED],
  [EventStatus.ARCHIVED]: [],
};
